
import { defineComponent } from 'vue'
import VitalDetail from './VitalDetail.vue'

export default defineComponent({
  name: 'VitalSigns',
  props: ['patient'], 
  components: {
    VitalDetail,
  },
  data: () => ({
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        title: 'Date',
        align: 'start',
        sortable: false,
        key: 'date',
      },
      { title: 'Time', key: 'time' },
      { title: 'Systolic', key: 'systolic' , sortable: false },
      { title: 'Diastolic', key: 'diastolic', sortable: false  },
      { title: 'Pulse', key: 'pulse', sortable: false },
      { title: 'Oxygen', key: 'oxygen', sortable: false },
      { title: 'Temperature', key: 'temperature', sortable: false },
      { title: 'Actions', key: 'actions', sortable: false },
    ],
    vitals: [],
    editedIndex: -1,
    editedItem: {
      date: '',
      time: '',
      systolic: '',
      diastolic: '',
      pulse: '',
      oxygen: '',
      temperature: ''
    },
    defaultItem: {
      date: '',
      time: '',
      systolic: '',
      diastolic: '',
      pulse: '',
      oxygen: '',
      temperature: ''
    },
  }),

  computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Add New Vitals' : 'Edit Vitals'
      },
    },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
  },

  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.vitals = [
        {
          date: '2023-04-01',
          time: '11:00',
          systolic: '180',
          diastolic: '20',
          pulse: '93',
          oxygen: '200',
          temperature: '32'
        },
        {
          date: '2023-04-01',
          time: '12:00',
          systolic: '190',
          diastolic: '90',
          pulse: '100',
          oxygen: '100',
          temperature: '40'
        }      
      ]
    },

    editItem (item) {
      this.editedIndex = this.vitals.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.editedIndex = this.vitals.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      this.vitals.splice(this.editedIndex, 1)
      this.closeDelete()
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.vitals[this.editedIndex], this.editedItem)
      } else {
        this.vitals.push(this.editedItem)
      }
      this.close()
    },

    onUpdateVital(value) {
      this.editedItem = value
    },
  },
})
